import React from "react";

import { useNavigate, useParams, useSearchParams, useLocation } from "react-router-dom";

const with_params = (Component) => {
  return (props) => <Component {...props} params={useParams()} navigate={useNavigate()} location={useLocation()} query={useSearchParams()} />;
};

export { with_params };
